<div class="container" *ngIf="!hideHeader">
    <div class="contact-us header-padding"  *ngIf="(isTablet$ | async) || (isMobile$ | async)">
        <div class="social-media">
            <img class="icon" *ngFor="let icon of headerIcons" [src]="icon.icon" (click)="redirectToLink(icon.link)"/>
        </div>
        <a class="p-d-flex phone-field" href="tel:+7{{mainNumber}}">
            <i class="pi pi-phone icon"></i>
            <span class="header-text">+7{{ mainNumber | mask: ' 000 000 00 00' }}</span>
        </a>
    </div>
    <div class="head header-padding wrapper-width">
        <div class="left">
            <img class="logo-image" (click)="redirectHome()" src="../../../assets/images/new-design-icons/logo/logo.svg"/>
            <ng-container *ngIf="!(isTablet$ | async) && !(isMobile$ | async)">
                <div class="line"></div>
                <div class="logo-header-text">
                    Маркетплэйс видеообзоров и хороших риелторов
                </div>
            </ng-container>
        </div>

        <div class="contact-us header-padding" *ngIf="!(isTablet$ | async) && !(isMobile$ | async)">
            <div class="social-media">
                <img class="icon" *ngFor="let icon of headerIcons" [src]="icon.icon" (click)="redirectToLink(icon.link)"/>
            </div>
            <a class="p-d-flex phone-field" href="tel:+7{{mainNumber}}">
                <i class="pi pi-phone icon"></i>
                <span class="header-text">+7{{ mainNumber | mask: ' 000 000 00 00' }}</span>
            </a>
        </div>
        <div class="right">
            <ng-container *ngIf="!(isMobile$ | async)">
                <div class="city">
                    <app-select
                        minHeightClass="32px"
                        [width]="'101px'"
                        [clearable]="false"
                        [control]="citySelect"
                        [itemList]="cityCollection$ | async"
                        [placeholder]="'Выберите город'"
                        [loading]="cityLoading$ | async"
                        (selected)="selectCity($event)"
                    ></app-select>
                </div>
                <app-button
                    style="margin: 0 16px; height: 32px;"
                    [icon]="'assets/images/new-design-icons/Plus (black).svg'"
                    [iconDirection]="'left'"
                    [buttonClass]="'small-white'"
                    [text]="'Подать заявку'"
                    (buttonClick)="sendBidClick()"
                    [buttonId]="'CLICK_APPLY_APPLICATION'"
                ></app-button>
            </ng-container>

            <div
              class="profile-button"
              (mousedown)="buttonState = 'down'"
              (mouseup)="buttonState = 'up'"
              [@pressState]="buttonState"
              (click)="menu.toggle($event)"
            >
                <img class="mr-8" src="../../../assets/images/new-design-icons/Burger%20(white).svg">
                <img src="../../../assets/images/new-design-icons/Empty%20Profile%20(white).svg">
            </div>
            <p-menu #menu [autofocus]="false" [popup]="true" [class]="'dropdown'" [model]="currentUser ? itemsUserIn : itemsUserOut"></p-menu>
        </div>
    </div>

    <div class="content wrapper-width" [class.header-padding]="!(isMobile$ | async)" *ngIf="checkIsShowFilters()">
        <div class="info-general-sold marquee-container">
            <div class="marquee">
              <span *ngFor="let i of repeatArray" class="item"><span>{{ message }}</span> <span class="circle"></span></span>
            </div>
        </div>
        <ng-container *ngIf="showImage">
            <div class="header-carousel">
<!--                <div class="integration-info">-->
<!--                    <div class="currency" *ngIf="currency">USD: {{ calculateCurrency(currency['USD']) }}</div>-->
<!--                    <div class="info-divider">|</div>-->
<!--                    <div class="currency" *ngIf="currency">EUR: {{ calculateCurrency(currency['EUR']) }}</div>-->
<!--                    <div class="info-divider">|</div>-->
<!--                    <div class="currency">Погода: {{temperature}}*C</div>-->
<!--                </div>-->
                <app-header-slider (clickImage)="bannerEvent($event)"></app-header-slider>

            </div>
        </ng-container>
        <div class="navigation" [class.header-padding]="(isMobile$ | async)">
            <app-nav [buttons]="navButtons" [buttonsPage]="navButtonsPage" [isMobile]="isMobile$ | async" [isTablet]="isTablet$ | async" (next)="searchData($event)"></app-nav>
        </div>
        <div class="filter" *ngIf="!(isMobile$ | async)" [class.standalone]="!showImage">
            <app-data-filter (searchEmit)="nextPage.emit($event)" [isHomePage]="showImage"></app-data-filter>
        </div>
    </div>
</div>
<app-sign-up *ngIf="isShowAuthorization" (visiblePanelChange)="visiblePanelChange($event, 'isShowAuthorization')"></app-sign-up>

<app-apply-application *ngIf="isShowApplyApplication" (visiblePanelChange)="visiblePanelChange($event, 'isShowApplyApplication')"></app-apply-application>
